/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Markers_Imported_ToastInputs */

const en_ocr_markers_imported_toast = /** @type {(inputs: Ocr_Markers_Imported_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR results imported as markers.`)
};

const fr_ocr_markers_imported_toast = /** @type {(inputs: Ocr_Markers_Imported_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résultats de la reconnaissance optique de caractères (OCR) importés sous forme de marqueurs.`)
};

const de_ocr_markers_imported_toast = /** @type {(inputs: Ocr_Markers_Imported_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR-Ergebnisse wurden als Marker importiert.`)
};

const it_ocr_markers_imported_toast = /** @type {(inputs: Ocr_Markers_Imported_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risultati OCR importati come marcatori.`)
};

const ru_ocr_markers_imported_toast = /** @type {(inputs: Ocr_Markers_Imported_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Результаты оптического распознавания символов импортированы в качестве маркеров.`)
};

const es_ocr_markers_imported_toast = /** @type {(inputs: Ocr_Markers_Imported_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultados de OCR importados como marcadores.`)
};

const zh_cn2_ocr_markers_imported_toast = /** @type {(inputs: Ocr_Markers_Imported_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR结果导入为标记。`)
};

const ja_ocr_markers_imported_toast = /** @type {(inputs: Ocr_Markers_Imported_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCRの結果がマーカーとしてインポートされます。`)
};

const hi_ocr_markers_imported_toast = /** @type {(inputs: Ocr_Markers_Imported_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR परिणामों को मार्कर के रूप में आयात किया गया।`)
};

const pt_pt2_ocr_markers_imported_toast = /** @type {(inputs: Ocr_Markers_Imported_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultados do OCR importados como marcadores.`)
};

/**
* | output |
* | --- |
* | "OCR results imported as markers." |
*
* @param {Ocr_Markers_Imported_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_markers_imported_toast = /** @type {((inputs?: Ocr_Markers_Imported_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Markers_Imported_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_markers_imported_toast(inputs)
	if (locale === "de") return de_ocr_markers_imported_toast(inputs)
	if (locale === "it") return it_ocr_markers_imported_toast(inputs)
	if (locale === "ru") return ru_ocr_markers_imported_toast(inputs)
	if (locale === "es") return es_ocr_markers_imported_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_markers_imported_toast(inputs)
	if (locale === "ja") return ja_ocr_markers_imported_toast(inputs)
	if (locale === "hi") return hi_ocr_markers_imported_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_markers_imported_toast(inputs)
	return en_ocr_markers_imported_toast(inputs)
});